/**
 * The run from the bottom of the tab pills to the top of a tab's first content
 * block. One constant because the gap has to read the same on every tab — they
 * were each carrying their own 3rem.
 *
 * 24px is not the whole gap: the tab band the pills sit in carries 24px of its
 * own below them, so what the reader sees is 48px. The Overview page expresses
 * the same 24 as a `SectionSpacer`, since it spaces off a spacer rather than
 * padding its first block.
 */
export const TAB_CONTENT_GAP = 'md:pt-[1.5rem]';

/**
 * The run from a tab's hairline rule to the content under it. Same 24px as the
 * gap above the rule, so every tab opens on the same rhythm however its first
 * block is built — a grid, a filter row or a map.
 */
export const TAB_RULE_GAP = 'md:pt-[1.5rem]';

/**
 * The shared page-title type (Figma 2354:55431): 200px Neue Haas over a 180px
 * line box, tracking -8.4px. Kept here because the grid tabs had drifted onto a
 * looser `leading-[0.92] tracking-[-0.12rem]` while the About / Contact /
 * Downloads titles already used the Figma values.
 */
export const PAGE_TITLE_TYPE =
    'md:text-[12.5rem] md:leading-[11.25rem] md:tracking-[-0.525rem]';

/**
 * Mobile override for a `SectionLabel` that a tab actually shows on mobile.
 *
 * `SectionLabel` is desktop-first — its mobile size is `2.21vw`, which is ~9px at
 * 414 because on the homepage the label only ever renders at desktop widths. A
 * label that survives to mobile has to read as a heading instead, so this matches
 * the numbered accordion's mobile trigger: 16px, medium, default tracking.
 */
export const MOBILE_SECTION_LABEL =
    'max-md:text-base max-md:font-medium max-md:tracking-normal';

/**
 * Below md, the About tab's 12 between the tab bar and its picture: what the
 * listing tabs put between the tab bar and their filter/search bar. Three of
 * it, 36, sits between that bar and their grid — so every tab opens on the
 * same rhythm.
 */
export const TAB_LISTING_GAP = 'max-md:pt-3';
export const TAB_LISTING_GRID_GAP = 'max-md:pt-9';
